import { createSelector } from '@ngrx/store';

import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

import { cartState } from '../root';

export const isCartCollectionTypeCatering = createSelector(cartState, (cart) => {
    if (!cart?.orderTypeId) return false;

    const config = new Statics.ConfigStatic().current;

    return new Utils.CollectionTypeGroupDetector(cart.orderTypeId, config).isCatering();
});
